(ns ycweb.app.website.cart.pages.cart-later
  (:require
   [clojure.string :as str]
   [rum.core :as rum]
   [ycweb.app.website.cart.model :as model]
   [ycweb.app.website.cart.parts.common :as cart.common]
   [ycweb.components.common :as cmn]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.buttons :as buttons]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc save-for-later-form < rum/reactive cmn/cursors
  {:will-mount
   (fn [state]
     (let [[app-atom process-atom cart-atom] (:rum/args state)
           cart-summary @cart-atom
           user (:user cart-summary)
           user-name
           (str/trim
             (str (:firstname user) " " (:lastname user)))
           user-email (or (:email user) "")]
       (when-not (get @process-atom :save-later)
         (swap! process-atom assoc :save-later
           {:name (if (str/blank? user-name) "" user-name)
            :email user-email}))
       state))}
  [app-atom process-atom cart-atom]
  "Save for later form - matches cart-save-for-later.html structure"
  (let [{:keys [user] :as cart-summary} (rum/react cart-atom)
        save-later-atom (rum/cursor-in process-atom [:save-later])
        save-later-data (rum/react save-later-atom)
        ;; Form validation - check required fields
        required-fields [:name :email]
        form-valid?
        (every?
          #(not (str/blank? (str (get save-later-data %))))
          required-fields)

        ;; Save cart for later function - just update the process atom
        ;; The actual save and navigation is handled by the after-update function in step-def
        save-cart-later
        (fn []
          ;; Update the process atom with the form data
          (swap! process-atom assoc-in [:save-later] save-later-data))]

    (cart.common/checkout-layout process-atom true

      [:div {:class "u-max-width-480"}
       [:h2 {:class "yc-heading yc-heading--default"}
        "Keen to check out later?"]

       [:p {:class "yc-paragraph"}
        "Not a problem. Fill in your details below, and we'll save your cart and email you a reminder link."]

         ;; Full name field
       (forms/input "Full name" "e.g. Jane Smith"
         (cmn/cursor-in save-later-atom [:name])
         {:type :user :required? true})

         ;; Email field
       (forms/input "Email address" "e.g. jane.smith@domain.com"
         (cmn/cursor-in save-later-atom [:email])
         {:type :email :required? true})]
      (cart.common/checkout-cta-sidebar app-atom process-atom cart-atom
        {:disabled? (not form-valid?)
         :continue-fn save-cart-later}))))

(rum/defc cart-saved-success < rum/reactive cmn/cursors
  [app-atom process-atom cart-atom]
  "Cart saved success page - matches cart-save-for-later-done.html structure"
  (cart.common/checkout-layout process-atom false
    [:div {:class "u-max-width-480"}
     [:h2 {:class "yc-heading yc-heading--default"}
      "Check your email"]

     [:p {:class "yc-paragraph"}
      "We've saved your cart and sent you an email reminder with a link to pick up where you left off later."]]

    (cart.common/checkout-cta-sidebar app-atom process-atom cart-atom
      {:continue-fn #(urlstate/navigate app-atom nil "/")})))

(defmethod cart.common/checkout-step :cart/save-for-later
  [app-atom process-atom cart-atom]
  (save-for-later-form app-atom process-atom cart-atom))

(defmethod cart.common/checkout-step :cart/saved
  [app-atom process-atom cart-atom]
  (cart-saved-success app-atom process-atom cart-atom))